/**
 * Constantes para o componente Avatar
 */

/**
 * Campos que indicam foto/avatar nos dados
 */
export const AVATAR_FIELDS = ['foto', 'avatar', 'photo', 'imagem', 'image', 'picture'];

/**
 * Campos que indicam nome nos dados
 */
export const NAME_FIELDS = ['nome', 'name', 'full_name', 'fullName', 'nomeCompleto'];

/**
 * Campos que indicam gênero nos dados
 */
export const GENDER_FIELDS = ['genero', 'gender', 'sexo'];

/**
 * Classes CSS para avatar baseado no gênero
 */
export const AVATAR_GENDER_CLASSES = {
    male: 'bg-blue-100 text-gray-900',
    female: 'bg-fuchsia-100 text-fuchsia-500',
    default: 'bg-blue-100 text-gray-900'
} as const;

/**
 * Tamanhos disponíveis para o avatar
 */
export const AVATAR_SIZES = {
    xs: 'w-7 h-7 text-[10px]',
    sm: 'w-9 h-9 text-[11px]',
    md: 'w-12 h-12 text-sm',
    lg: 'w-16 h-16 text-xl'
} as const;

export type AvatarSize = keyof typeof AVATAR_SIZES;
